import ConfirmationDialog from "@/shared/components/domain/confirmation/confirmation-dialog";
import {
  useErrArtefactNotReady,
  useSetErrArtefactNotReadyFromRtk,
} from "@/shared/service-manager/artefact/err-artefact-not-ready";
import { Button } from "@/shared/components/ui/button";
import { ReactElement } from "react";
import { Trash } from "lucide-react";
import { useDeleteErrorMutation } from "@/services/backend/sample-error/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface DeleteErrorButtonProps {
  errorId: string;
}

export default function DeleteErrorButton({
  errorId,
}: DeleteErrorButtonProps): ReactElement {
  const [deleteError, { error, reset, isLoading }] = useDeleteErrorMutation();
  const { resetNotReadyError } = useErrArtefactNotReady();
  useSetErrArtefactNotReadyFromRtk(error, () => {
    reset();
  });
  const onConfirm = () => {
    if (isLoading) {
      return;
    }

    resetNotReadyError();
    deleteError({
      id: errorId,
    });
  };

  return (
    <>
      <RTKQueryErrorAlert error={error} />
      <ConfirmationDialog
        trigger={
          <Button className="bg-red-600">
            <Trash />
          </Button>
        }
        title="Fehler löschen"
        description="Hiermit wird der Fehler aus den Stammdaten gelöscht. Der Fehler bleibt jedoch bei Prozessen erhalten!"
        onConfirm={onConfirm}
      />
    </>
  );
}
